export const environment = {
  baseUrl: 'https://api.qa3.prime.sportsmed.smith-nephew.com',
  baseAdminUrlClp: 'https://api-snn.qa3.bridge.sportsmed.smith-nephew.com/adminclp',
  baseUnauthUrl: 'https://api2.qa3.prime.sportsmed.smith-nephew.com',
  baseUrlCLP: 'https://api.qa3.bridge.sportsmed.smith-nephew.com/clp',
  baseUrlDUU: 'https://api.qa3.bridge.sportsmed.smith-nephew.com',
  lensSenderEmail: 'snn-no.reply@qa3.prime.sportsmed.smith-nephew.com',
  identityPoolId: 'us-east-2:0ee99cf3-b2fc-4b6d-b4c7-ae6be8776036',
  userPoolId: 'us-east-2_WSC08E2mA',
  userPoolWebClientId: '18k7gs6sakebf8fj80fu1jtaq', //LensAppClient_WEB
  userPoolAwsLogin: 'cognito-idp.us-east-2.amazonaws.com/us-east-2_WSC08E2mA',
  region: 'us-east-2',
  production: true,
  locales: ['en'],
  defaultLocale: 'en',
  backendUrl: 'https://api.qa3.prime.sportsmed.smith-nephew.com/hil',
  backendUrlLogger: 'https://api.qa3.prime.sportsmed.smith-nephew.com/logger',
  bucketForMask: 'prime-qa3-bucket-samd-segmentation-image-repo',
  bucketForImage: 'prime-qa3-bucket-samd-raw-image-repo',
  bucketForTibiaMask: 'prime-qa3-bucket-samd-segmentation-image-repo-tibia',
  bucketForTibiaImage: 'prime-qa3-bucket-samd-raw-image-repo-tibia',
  hostedUIUrl: 'https://bridge-qa3-snn-auth.auth.us-east-2.amazoncognito.com/oauth2/', //Bridge SSN Cognito URL
  hostedUIlogout: 'https://bridge-qa3-snn-auth.auth.us-east-2.amazoncognito.com/logout', //Bridge SSN Cognito URL
  maintenanceValue: 'Z8X7C6V5B4N3M2A1S0D9F8G7H6J5K4L3',
  maintenancePublicKey: '-----BEGIN RSA PUBLIC KEY-----\nMIIBCgKCAQEApJFWSRRJMDIX01M9GzIJiFvaIhyDG5qLl1bpw5PhshEMM3ju0DOn\np01q6HxxZYms7ag8z3O0xOrI3QCDD/j68LY9kaANhkQz5rgMGPMFpALMqEQTirQl\nNggQ95l9rvcwoGBnqKUZ24W4ofJVOh6k5YkmCklSRm5RxbA2oPCu+ENywNmrnILW\nfVvShld6R86P0V5md1Fws6oo3DWmyTav/vg4+3nlFwTNcy5vlTOGmMiOLDHhYfbx\nq3fLYnSSPJOMr9GDu921PpAvQsqFrCspu+iMXN759gPVAemSzfh+2KngrhTkZlaO\nqTCt2jYhwObEevpMS7115RFvIYrSEUqxFQIDAQAB\n-----END RSA PUBLIC KEY-----\n',
    ssmParams: {
    MODEL_REQUEST_DELAY: '/prime-qa3/hil-service/ModelRequestDelay',
    BIG_MODEL_REQUEST_DELAY: '/prime-qa3/hil-service/BigModelRequestDelay',
    DEFAULT_NUMBER_OF_ATTEMPTS: '/prime-qa3/hil-service/DefaultNoAttempts',
    APPVERSION: '/prime-qa3/hil-service/hilappVersionInfo',
    PRIMESEGVERSION: '/prime-qa3/hil-service/primesegVersionInfo',
    IDLETIME : '/prime-qa3/hil-service/inactivityTime_login',
    DISABLE_HIL_VALIDATION: '/prime-qa3/hil-service_qa3/disableChecksumForHIL',
    TIBIASEGVERSION: '/prime-qa3/hil-service/tibiasegVersionInfo'
  },
  cloudfrontCLPURL: 'https://snn.qa3.bridge.sportsmed.smith-nephew.com', //Bridge SNN CF domain name
  cloudFrontCLPSignInUrl: 'https://snn.qa3.bridge.sportsmed.smith-nephew.com/signin', //Bridge SNN CF domain name
  cloudFrontCLPSignOutUrl: 'https://snn.qa3.bridge.sportsmed.smith-nephew.com/logout', //Bridge SNN CF domain name
  cloudFrontCLPExitAppUrl: 'https://snn.qa3.bridge.sportsmed.smith-nephew.com/application/product', //Bridge SNN CF domain name
  hilCloudFrontSigninUrl: 'https://web-portal.qa3.prime.sportsmed.smith-nephew.com/signin' //Prime CF domain name
};
